export const FIXED_UPDATE_HZ = 120;
export const FIXED_UPDATE_DT = 1 / FIXED_UPDATE_HZ;
export const DEFAULT_RENDER_FPS_CAP = 60;
export const THERMAL_RENDER_FPS_CAP = 30;

// More than about 50ms of catch-up can apply too much input, collision,
// camera, and audio state in one rendered frame. Drop the excess time
// instead; a brief slowdown feels better than a lurch.
export const MAX_GAMEPLAY_CATCHUP_SECONDS = 0.05;
export const MAX_GAMEPLAY_CATCHUP_STEPS = Math.ceil(
  FIXED_UPDATE_HZ * MAX_GAMEPLAY_CATCHUP_SECONDS,
);

// Slow-frame diagnostics should stay tied to the render budget, not the
// smaller 120Hz physics step. 1.5 frames at the default 60Hz cap is 25ms.
export const SLOW_FRAME_THRESHOLD_STEPS = FIXED_UPDATE_HZ * (1.5 / DEFAULT_RENDER_FPS_CAP);

// Visual springs should not consume a huge dropped-frame delta. 30Hz is still
// a valid playable cadence, while worse hitches get smoothed over visually.
export const MAX_VISUAL_SMOOTHING_DT = 1 / 30;

export function clampVisualSmoothingDt(frameDt: number): number {
  if (!Number.isFinite(frameDt) || frameDt <= 0) return 0;
  return Math.min(frameDt, MAX_VISUAL_SMOOTHING_DT);
}

export function parseRenderFpsCap(value: string | null): number {
  if (value === null || value.trim() === '') return DEFAULT_RENDER_FPS_CAP;
  const normalized = value.trim().toLowerCase();
  if (normalized === 'off' || normalized === 'false' || normalized === 'uncapped' || normalized === '0') {
    return Number.POSITIVE_INFINITY;
  }
  const parsed = Number(normalized);
  if (!Number.isFinite(parsed) || parsed <= 0) return DEFAULT_RENDER_FPS_CAP;
  return Math.max(15, Math.min(240, parsed));
}
